import React from 'react';
// import getConfig from 'next/config';
import { Grid, Typography, Box, styled, Button } from '@quillbot/design-system';
import { makeStyles } from '@quillbot/design-system';
import { createStyles } from '@quillbot/design-system';
// import { detectAgent } from 'core/utils';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import BackToTopButton from '@Common/components/BackToTopButton';
import { useRouter } from 'next/router';
import SocialIcons from './SocialIcons';
import BottomMessage from './BottomMessage';
import CornMessage from './CornMessage';
import { openConsentForm, showCookieLinks } from '@Common/handlers/oneTrust';
// const { publicRuntimeConfig } = getConfig();

const StyledCookieButton = styled(Button)(({ theme }) => ({
  border: 'none',
  padding: '0px',
  margin: '0px',
  fontSize: '12px',
  color: theme.palette.text.primary,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const useStyles = makeStyles((theme) =>
  createStyles({
    /* newsletterHolder: {
      maxWidth: '340px',
      width: '100%',
      float: 'right',
      "& input[type='email']": {
        'min-width': '205px !important',
        borderRadius: '4px 0px 0px 4px !important',
        border: '1px #fff solid',
        height: '39px',
      },
      '& .klaviyo-form': {
        [theme.breakpoints.down(959)]: {
          width: '100%',
        },
      },
      '& div.needsclick ': {
        padding: '0px !important',
        alignItems: 'center',
        float: 'left',
        [theme.breakpoints.down(959)]: {
          padding: '0px !important',
        },
      },
      '& button.needsclick ': {
        margin: '0px 0px 0px -1px !important',
        borderRadius: '0px 4px 4px 0px  !important',
        [theme.breakpoints.down(959)]: {
          margin: '0px 0px 0px -1px !important',
          borderRadius: '0px 4px 4px 0px  !important',
        },
      },
      '& >div.needsclick': {
        aligItems: 'flex-start',
        width: '100%',
      },
      '& div.needsclick > div.needsclick > div.needsclick > div.needsclick': {
        alignSelf: 'flex-start',
      },
      [theme.breakpoints.down(959)]: {
        float: 'left',
      },
      [theme.breakpoints.down(767)]: {
        maxWidth: '100%',
        float: 'left',
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        marginTop: '30px',
      },
    }, */
    /*
    gridreversemobile: {
      [theme.breakpoints.down(767)]: {
        'flex-direction': 'column-reverse',
      },
      '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        'flex-direction': 'inherit',
        '-ms-flex-direction': 'inherit',
      },
    },
    /* footerTitle: {
      color: 'white',
      fontSize: '14px',
      fontWeight: 'bold',
      textAlign: 'left',
      paddingLeft: '12px',
      width: '100%',
      marginBottom: '10px',
      maxWidth: '313px',
      [theme.breakpoints.down(959)]: {
        maxWidth: '100%',
        float: 'left',
        paddingLeft: '0px',
      },
    }, */

    footerBottomCopyright: {
      marginTop: '37px',
      marginBottom: '12px',

      [theme.breakpoints.down(900)]: {
        marginTop: '40px',
        marginBottom: '7px',
      },
    },

    copyRightSection: {
      marginRight: '56px',
      [theme.breakpoints.down(900)]: {
        marginRight: '16px',
      },
    },

    footerContainerHolder: {
      backgroundColor: theme.palette.background.default,
      padding: '40px 0px 25px',
      position: 'relative',
      borderTop: '1px solid',
      color: theme.palette.divider,
    },

    footerContainer: {
      padding: '0px 7%',
      margin: 'auto',
      [theme.breakpoints.down(1400)]: {
        maxWidth: '100%',
        padding: '0px 98px',
      },

      [theme.breakpoints.down(1200)]: {
        maxWidth: '100%',
        padding: '0px 36px',
      },

      [theme.breakpoints.down(960)]: {
        maxWidth: '100%',
        padding: '0px 36px',
      },

      [theme.breakpoints.down(900)]: {
        maxWidth: '100%',
        padding: '0px 25px',
      },

      '& a:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
        // color: '#f1f1f1',
      },
    },

    socialIconHeader: {
      marginTop: 5,
      flexDirection: 'column',
      alignItems: 'flex-end',
      textAlign: 'right',
      [theme.breakpoints.down(960)]: {
        alignItems: 'flex-start',
        marginTop: '26px',
        textAlign: 'left',
      },
    },

    footerDot: {
      width: '4px',
      height: '4px',
      background: theme.palette.text.secondary,
      borderRadius: '50%',
    },
    footerItems: {
      marginRight: '52px',
      [theme.breakpoints.down(1200)]: {
        marginRight: '48px',
      },
      [theme.breakpoints.down(900)]: {
        marginRight: '48px',
      },
      '& h6': {
        fontSize: '14px',
        fontWeight: '700',
        marginBottom: '13px',
      },
      '& a': {
        display: 'block',
        marginTop: '0px',
        marginBottom: '16px',
        fontSize: '14px',
        [theme.breakpoints.down(900)]: {
          marginBottom: '11px',
        },
      },
      '& a:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
        // color: '#f1f1f1',
      },

      [theme.breakpoints.down(980)]: {
        marginRight: '40px',
      },
      [theme.breakpoints.down(960)]: {
        marginBottom: '20px',
      },

      [theme.breakpoints.down(350)]: {
        marginRight: '35px',
      },
    },
    footerSocialHolder: {
      [theme.breakpoints.down(958)]: {
        marginTop: '20px',
      },
    },
    footerLinkColor: {
      color: theme.palette.text.primary,
    },
  })
);
function Footer() {
  const classes = useStyles();
  const router = useRouter();
  // const [agent, setAgent] = useState({
  //   isMobile: false,
  //   isIE: false,
  // });
  // useEffect(() => {
  //   const detectedAgent = detectAgent();
  //   setAgent({
  //     isMobile: !!detectedAgent.isMobile,
  //     isIE: !!detectedAgent.isIE,
  //   });
  // }, []);
  const isKeyboardOpen = useSelector((state: RootState) => state.common.isKeyboardOpen);
  const isPremium = useSelector((state: RootState) => state.user?.premium);
  const platform = useSelector((rootState: RootState) => rootState.common.platform);
  const isCampaign = useSelector((rootState: RootState) => rootState.common.campaign);
  if (platform.isExtension === true) {
    return null;
  }
  const renderLinkSection = (linkName: string, hrefLink: string) => (
    <Link href={hrefLink} target="_blank" rel="noopener noreferrer" className={classes.footerLinkColor}>
      {linkName}
    </Link>
  );
  const renderCompanySection = () => (
    <Box className={classes.footerItems}>
      <Typography variant="h6" display="block">
        Company
      </Typography>
      {renderLinkSection('Team', '/about')}
      {renderLinkSection('Blog', 'https://quillbot.com/blog/')}
      {/*<a
        href="https://quillbot.com/blog/"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.footerLinkColor}
      >
        Blog
      </a>*/}
      {renderLinkSection('Courses', isCampaign ? 'https://quillbot.com/courses/' : '/courses/')}
      {renderLinkSection('Contact Us', '/contact')}
      {renderLinkSection('Careers', '/careers')}
    </Box>
  );
  const renderSupportSection = () => (
    <Box className={classes.footerItems}>
      <Typography variant="h6" display="block">
        Resources
      </Typography>
      {renderLinkSection('Help Center', 'https://help.quillbot.com/hc/en-us')}
      {renderLinkSection('Student Resources', '/student-resources')}
      {renderLinkSection('Paraphrasing Guide', '/guides/paraphrasing')}
      {renderLinkSection('AI Writing Assistant', '/guides/ai-writing-assistant')}
    </Box>
  );
  const renderProductSection = () => (
    <Grid className={classes.footerItems}>
      <Typography variant="h6" display="block">
        Products
      </Typography>
      {renderLinkSection('Paraphrasing Tool', isCampaign ? 'https://quillbot.com' : '/')}
      {renderLinkSection('Grammar Checker', '/grammar-check')}
      {renderLinkSection('Plagiarism Checker', '/plagiarism-checker')}
      {renderLinkSection('Co-Writer', '/co-writer')}
      {renderLinkSection('Summarizer', '/summarize')}
      {renderLinkSection('Citation Generator', '/citation-generator')}
      {renderLinkSection('Word Counter', '/word-counter')}
    </Grid>
  );
  const renderServicesSection = () => (
    <Box className={classes.footerItems}>
      <Typography variant="h6" display="block">
        Services
      </Typography>
      {renderLinkSection('Premium', '/premium?referrer=footer')}
      {/* {renderLinkSection('API Access', '/api-access')} */}
      {renderLinkSection('Affiliate', '/affiliates')}
    </Box>
  );
  const renderConsentSection = () => (
    <Typography
      variant="caption"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
      }}>
      &nbsp;&nbsp;
      <span className={classes.footerDot}>&nbsp;</span>
      &nbsp;&nbsp;
      <Link href="/cookie-policy">
        <a rel="noopener noreferrer" target="_blank" className={classes.footerLinkColor}>
          Cookie Policy
        </a>
      </Link>
      &nbsp;&nbsp;
      <span className={classes.footerDot}>&nbsp;</span>
      &nbsp;&nbsp;
      {/* <div id="ot-sdk-btn" className={`ot-sdk-show-settings ${classes.cookieButton}`}> */}
      <StyledCookieButton
        disableElevation
        disableRipple
        disableTouchRipple
        disableFocusRipple
        onClick={openConsentForm}>
        Cookie Settings
      </StyledCookieButton>
    </Typography>
  );
  return (
    <>
      {(router.pathname === '/' && isPremium) ||
      router.pathname === '/summarize' ||
      router.pathname === '/grammar-check' ||
      isKeyboardOpen ? null : (
        <BackToTopButton />
      )}
      <div style={{ display: isKeyboardOpen ? 'none' : 'inherit' }}>
        <div className={classes.footerContainerHolder}>
          <div className={classes.footerContainer}>
            <Grid container>
              <Grid item xs={12} xl={7} lg={7} sm={12} md={7}>
                <Grid container>
                  {renderProductSection()}
                  {renderServicesSection()}
                  {renderSupportSection()}
                  {renderCompanySection()}
                </Grid>
              </Grid>

              <Grid item xs={12} xl={5} lg={5} sm={12} md={5}>
                <Box className={classes.socialIconHeader}>
                  <SocialIcons />
                </Box>
              </Grid>

              {/* <Grid item xs={12} xl={5} lg={5} sm={12} md={5}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                  className={classes.newsletterHolder}>
                  <Typography variant="body2" display="block" className={classes.footerTitle}>
                    Connect
                  </Typography>
                  <Box
                    style={{
                      marginBottom: '30px',
                    }}
                    className={publicRuntimeConfig.KLAVIO_CLASSNAME}
                  />
                </Box>
              </Grid> */}
            </Grid>
            <Grid
              container
              //   style={{ padding: '33px 0px 15px' }}
              className={classes.footerBottomCopyright}>
              <Grid item xs={12} xl={12} lg={12} sm={12} md={12}>
                <Typography className={classes.copyRightSection} variant="caption">
                  © QuillBot (Course Hero), LLC. 2022
                </Typography>
                <Typography
                  variant="caption"
                  // className={classes.footerCopyrights}
                  style={{
                    // color: 'white',
                    display: 'inline-flex',
                    alignItems: 'center',
                  }}>
                  {renderLinkSection('Privacy Policy', '/privacy')}
                  {/*<Link href="/privacy">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      className={classes.footerLinkColor}
                    >
                      Privacy Policy
                    </a>
                  </Link>*/}
                  &nbsp;&nbsp;
                  <span className={classes.footerDot}>&nbsp;</span>
                  &nbsp;&nbsp;
                  {renderLinkSection('Terms of Service', '/terms')}
                  {/*<Link href="/terms">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      className={classes.footerLinkColor}
                    >
                      Terms of Service
                    </a>
                  </Link>*/}
                  &nbsp;&nbsp;
                  <span className={classes.footerDot}>&nbsp;</span>
                  &nbsp;&nbsp;
                  {renderLinkSection('CCPA', '/ccpa')}
                  {/*<Link href="/ccpa">
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      className={classes.footerLinkColor}
                    >
                      CCPA
                    </a>
                  </Link>*/}
                  {/* Commenting this out till we have cookie banner live */}
                  {/* {showCookieLinks() && renderConsentSection()} */}
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} xl={6} lg={6} sm={12} md={6}>
                <BottomMessage />
              </Grid>
              <Grid item xs={12} xl={6} lg={6} sm={12} md={6} className={classes.footerSocialHolder}>
                <Grid container alignItems="center">
                  <Grid item xs={12} style={{ textAlign: 'right' }}>
                    <CornMessage />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
